import { render, staticRenderFns } from "./CsuDiseaseActivityPhase.vue?vue&type=template&id=35c37fc7&scoped=true&"
import script from "./CsuDiseaseActivityPhase.vue?vue&type=script&lang=js&"
export * from "./CsuDiseaseActivityPhase.vue?vue&type=script&lang=js&"
import style0 from "./CsuDiseaseActivityPhase.vue?vue&type=style&index=0&id=35c37fc7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c37fc7",
  null
  
)

export default component.exports